import * as React from "react";

function SvgUser(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.89 21.94"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path
        d="M22.87 19.14c-1-.95-4.57-1.84-6.41-2.73a3.46 3.46 0 01-1.85-3.08 2.46 2.46 0 01.75-1.5 9 9 0 001.71-5.84c0-4.1-2.46-5.95-5.19-5.95S6.69 1.85 6.69 5.99a9.14 9.14 0 001.71 5.88 2.46 2.46 0 01.75 1.5 3.45 3.45 0 01-1.84 3.08c-1.84 1-5.53 1.85-6.42 2.73A4.84 4.84 0 000 21.99h23.95c-.19-.11-.19-2-1.08-2.85z"
        fill="#1d1d1b"
      />
    </svg>
  );
}

const MemoSvgUser = React.memo(SvgUser);
export default MemoSvgUser;
